export default __webpack_public_path__ + "static/media/numero-de-aplicacoes.e880e5ec.svg";